<div class="wrapper">
  <img src="/assets/images/td-nest.svg" id="td-nest" alt="ยินดีต้อนรับ TD NEST" />
  <div class="background-wrapper">
    <img src="/assets/images/outer-nest.svg" id="outer-nest" alt="outer-nest" />
  </div>
  <img src="/assets/images/bird-fly.svg" id="bird-fly" alt="bird-fly" />
</div>
